import { Link } from 'react-router-dom';
import { LegalDocument, LegalDoc, Lang, useLang, CONTACT_EMAIL } from './LegalLayout';

const DOCS: Record<Lang, LegalDoc> = {
  ja: {
    eyebrow: 'Terms',
    title: '利用規約',
    lead: '本利用規約（以下「本規約」）は、ステイドリームホテル（以下「当施設」）の予約サイトおよび宿泊サービスのご利用条件とハウスルールを定めるものです。お客様に安全かつ快適にお過ごしいただくため、ご予約の前に必ずお読みください。',
    sections: [
      { title: '適用', body: ['本規約は、当施設の予約サイト（以下「本サイト」）を通じた予約および宿泊に関する一切の関係に適用されます。本サイトで予約を行った時点で、本規約に同意したものとみなします。', '本規約をお守りいただけない場合は、宿泊または施設のご利用をお断りすることがあります。また、本規約を守られないことによって生じた事故について、当施設は責任を負いかねます。'] },
      { title: '予約の成立', body: ['ご予約は、本サイト上で必要事項を入力し、決済が完了した時点で成立します。決済が完了しない場合、予約は成立しません。'] },
      { title: '料金・お支払い', list: ['宿泊料金は予約画面に表示される金額（税込）とします。', 'お支払いはクレジットカード等、本サイトが指定する方法によります。', '宿泊税その他の公租公課が別途発生する場合があります。', '追加料金・違約金は、チェックアウト日までにお支払いいただきます。'] },
      { title: 'キャンセルポリシー', list: ['チェックイン30日前まで：全額返金', 'それ以降のキャンセル・不泊（ノーショー）：返金不可', '長期利用で途中キャンセルとなった場合、返金はありません。', '返金は決済に使用した方法で行い、決済代行手数料等が差し引かれる場合があります。', 'Airbnb等の他の予約サイトで予約された場合は、各サイトのキャンセルポリシーに従います。'] },
      { title: 'チェックイン・チェックアウト', list: ['チェックイン：16:00以降', 'チェックアウト：10:00まで', '時間を厳守し、チェックアウト手順に従ってください。'] },
      { title: '施設のご利用について', list: [
        '施設内はバルコニーを除き土足厳禁です。室内用スリッパを履いたまま外出しないでください。',
        '施設内はバルコニーを含め全面禁煙です。住宅街のため、火災には十分ご注意ください。',
        '予約（登録）されたお客様・人数でご利用ください。予約者以外の宿泊、異なる人数での利用・滞在は禁止します。',
        'ご在室中、特に就寝時は必ず内鍵をおかけください。到着後、施設内の避難経路をご確認ください。',
        '外出時は、全館の窓・ドアを閉め、エアコン・テレビ・照明などの電源をお切りください。',
        'パーティー等で騒ぎ立てることは固く禁止します。特に21時から7時までは近隣に配慮し、お静かにお過ごしください。',
        '当施設の許可なく、展示会・事務所など宿泊以外の目的で客室を利用しないでください。',
        'ペットの宿泊はお断りしています。',
        '未成年者のみのご宿泊は、保護者の許可がない限りお断りします。',
        '外国人旅行者の方は、法令に基づき事前にパスポートのコピーをいただきます。',
        'トイレは座ってご使用いただき、トイレットペーパー以外は流さないでください。',
        '長期の宿泊利用により、居住に関する法律上の権利が発生するものではありません。',
      ] },
      { title: '電気のご使用について', body: ['施設ごとに電気の契約容量に上限があり、コンセント1か所あたりの上限は通常15Aです。窓を開けたままのエアコン使用や、1か所のコンセントで大電流の機器を使用すると、自動的に電源が切れ、停電につながることがあります。エアコン使用時は窓・ドアを閉め、電気・水道は節度をもってご使用ください。'] },
      { title: '備品・ゴミについて', list: [
        '家具・家電・寝具等は丁寧にお使いください。破損・汚損した場合は速やかにお知らせください。',
        '当施設の許可なく、家具・家電・備品を移動・改造しないでください。備品の持ち帰りは禁止です。',
        'ゴミは「可燃ゴミ」「不燃ゴミ」「カン・ビン・ペットボトル」に分別し、施設内の所定のゴミ箱に入れてください。詳しくは施設内のご案内に従ってください。',
        'フェイスタオル・バスタオルは最初にご提供した数のみで、追加・交換はできません。',
        '掃除用具をご用意していますので、室内を清潔に保つようお願いします。',
      ] },
      { title: '玄関ドアの鍵について', list: ['外出の際は必ず施錠してください。', '予約されたお客様以外に、玄関ドアの鍵（暗証番号等）を知らせないでください。', '鍵は大切に保管してください。紛失された場合は高額な費用（100,000円以上）が発生します。'] },
      { title: '違約金・損害賠償', body: ['次の場合、以下の違約金・弁償金を請求させていただきます。'], list: [
        '施設内での喫煙：500,000円（高額になります。）',
        '宿泊人数のオーバー、虚偽人数での予約、予約者以外の利用・滞在：超過または虚偽の1名につき15,000円/泊',
        '家具・家電・寝具・備品等の破損・汚損：同等の新品の価格。故意または過失がある場合は、復旧までの休業補償もあわせて請求します。',
        '嘔吐等による家具・寝具・備品等の汚損：理由を問わず一律100,000円',
        '玄関ドアの鍵の紛失：実費（100,000円以上）',
        '持ち込み禁止物・禁止行為（第12条）：300,000円以上',
      ] },
      { title: 'ご利用をお断りする場合', body: ['ご利用者が次のいずれかに該当すると認められる場合は、直ちにご利用をお断りし、退去していただきます。ご予約後またはご利用中に判明した場合も同様とし、返金はいたしません。'], list: [
        '暴力団員、暴力団関係団体・関係者、その他反社会的勢力であると判明した場合',
        '暴力、脅迫、恐喝、威圧的な不当要求またはこれに類する行為が認められる場合',
        '過去に当施設から利用の拒否を通告された方',
        '賭博や風紀を乱す行為、近隣の迷惑となる言動をした場合',
        '薬物・飲酒等によりご自身の安全確保が困難な場合、または近隣に危険・不安を及ぼすおそれがある場合',
        '大声・放歌・喧騒な行為等で他者に迷惑を及ぼした場合',
        '本規約に違反し、改善が見られない場合、その他上記に類する行為がある場合',
      ] },
      { title: '持ち込み禁止物・禁止行為', body: ['次の持ち込み・行為が判明した場合は、直ちにご利用をお断りし、退去していただきます。'], list: [
        '動物、鳥、その他のペット類の持ち込み',
        '火薬、揮発油、その他発火または引火性の物、悪臭を発する物の持ち込み',
        '法令等により所持を禁じられている物の持ち込み',
        '当施設の許可のない広告・宣伝物の配布、物品の販売、勧誘等',
        '当施設の許可のない営業目的の写真・ビデオ撮影等',
      ] },
      { title: '免責事項', list: [
        'お客様の財産・安全の損失について、当施設の責に帰さない場合、当施設は責任を負いません。貴重品はご自身で管理してください。',
        '天災・事件・設備の故障等により施設が使用できなくなった場合、利用できない日以降の宿泊料金は返金しますが、交通費等その他の損失は補償いたしません。',
      ] },
      { title: '本規約の変更', body: ['当施設は必要に応じて本規約を変更することがあります。変更する場合は、変更内容と効力発生日を、効力発生日の1週間前までに本サイトに掲載します。効力発生日以降にご利用された場合、変更に同意したものとみなします。'] },
      { title: '準拠法・管轄', body: ['本規約は日本法に準拠します。本規約に関する紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。'] },
    ],
    dates: ['制定日：2026年10月9日'],
  },
  en: {
    eyebrow: 'Terms',
    title: 'Terms of Service',
    lead: 'These Terms of Service ("Terms") set out the conditions and house rules for using the booking site and accommodation services of Stay Dream Hotel ("we" or "the Property"). To ensure a safe and comfortable stay, please read them before making a reservation.',
    sections: [
      { title: 'Scope', body: ['These Terms apply to all reservations and stays made through our booking site (the "Site"). By making a reservation, you agree to these Terms.', 'If these Terms are not observed, we may refuse your stay or use of the facilities. We are not responsible for any accidents caused by failure to observe these Terms.'] },
      { title: 'Reservation', body: ['A reservation is confirmed once the required information has been entered and payment has been completed on the Site. Without completed payment, no reservation is made.'] },
      { title: 'Rates and Payment', list: ['Rates are as displayed on the booking screen (tax included).', 'Payment is made by credit card or other methods designated on the Site.', 'Accommodation tax or other public charges may apply separately.', 'Additional charges and penalties must be paid by the check-out date.'] },
      { title: 'Cancellation Policy', list: ['Up to 30 days before check-in: full refund', 'After that, or in case of no-show: non-refundable', 'For long-term stays, no refund is given for early termination.', 'Refunds are made to the original payment method; processing fees may be deducted.', 'Bookings made via Airbnb or other sites follow the cancellation policy of each site.'] },
      { title: 'Check-in / Check-out', list: ['Check-in: from 16:00', 'Check-out: by 10:00', 'Please observe these times and follow the check-out procedure.'] },
      { title: 'Use of the Property', list: [
        'No shoes indoors except on the balcony. Do not go outside wearing the indoor slippers.',
        'Smoking is prohibited everywhere, including the balcony. As this is a residential area, please be careful of fire.',
        'Only the registered guests may stay, in the registered number. Stays by non-registered persons or a different number of guests are prohibited.',
        'Please lock the door from inside while in the room, especially when sleeping. Please check the evacuation route in the Property upon arrival.',
        'When going out, close all windows and doors and turn off the air conditioner, TV and lights.',
        'Parties and loud noise are strictly prohibited. Please be especially quiet between 21:00 and 7:00.',
        'Do not use the rooms for purposes other than accommodation (exhibitions, offices, etc.) without permission.',
        'Pets are not allowed.',
        'Minors may not stay without a guardian unless parental permission is given.',
        'Foreign travelers are required by law to provide a copy of their passport in advance.',
        'Please sit when using the toilet and do not flush anything other than toilet paper.',
        'Long-term stays do not create any legal rights of residence.',
      ] },
      { title: 'Electricity', body: ['Each property has a limited electricity capacity, and each outlet is generally limited to 15A. Using the air conditioner with windows open, or high-power appliances on a single outlet, may trip the power and cause a blackout. Please close windows and doors when using the air conditioner, and use electricity and water responsibly.'] },
      { title: 'Furnishings and Garbage', list: [
        'Please handle furniture, appliances and bedding with care. Report any damage or stains promptly.',
        'Do not move or modify furniture, appliances or items without permission. Taking items home is prohibited.',
        'Sort garbage into "burnable", "non-burnable" and "cans / bottles / PET bottles", and put it in the designated bins in the Property. Please follow the in-house guide for details.',
        'Face and bath towels are provided only in the initial quantity; no additions or replacements.',
        'Cleaning tools are provided; please keep the rooms clean.',
      ] },
      { title: 'Entrance Door Key', list: ['Always lock the door when going out.', 'Do not share the door key (or access code) with anyone other than registered guests.', 'Keep the key safe. Loss of the key will incur a high cost (JPY 100,000 or more).'] },
      { title: 'Penalties and Damages', body: ['The following penalties and compensation will be charged:'], list: [
        'Smoking inside the Property: JPY 500,000 (a high penalty applies)',
        'Exceeding the number of guests, false guest numbers, or stays by non-registered persons: JPY 15,000 per excess person per night',
        'Damage or stains to furniture, appliances, bedding or items: the price of an equivalent new item, plus loss of business until restoration if caused intentionally or by negligence',
        'Soiling of furniture, bedding or items by vomit, etc.: a flat JPY 100,000 regardless of cause',
        'Loss of the entrance door key: actual cost (JPY 100,000 or more)',
        'Prohibited items or acts (Article 12): JPY 300,000 or more',
      ] },
      { title: 'Refusal of Use', body: ['If a guest falls under any of the following, we will immediately refuse use and require the guest to leave, including when discovered after booking or during the stay, without refund.'], list: [
        'Members of organized crime groups or related organizations, or other anti-social forces',
        'Violence, threats, extortion, intimidating unreasonable demands or similar acts',
        'Persons previously notified of refusal by the Property',
        'Gambling, acts disturbing public morals, or behavior that bothers neighbors',
        'Inability to ensure one\'s own safety due to drugs or alcohol, or risk of causing danger or anxiety to neighbors',
        'Shouting, loud singing or rowdy behavior that disturbs others',
        'Repeated violation of these Terms without improvement, or other acts similar to the above',
      ] },
      { title: 'Prohibited Items and Acts', body: ['If any of the following is found, we will immediately refuse use and require the guest to leave.'], list: [
        'Bringing animals, birds or other pets',
        'Bringing gunpowder, volatile oil or other flammable items, or items with offensive odors',
        'Bringing items prohibited by law',
        'Distributing advertisements, selling goods or soliciting without permission',
        'Commercial photography or video recording without permission',
      ] },
      { title: 'Disclaimer', list: [
        'We are not liable for loss of guests\' property or safety not attributable to us. Guests are responsible for their own valuables.',
        'If the Property becomes unusable due to natural disasters, incidents or equipment failure, we will refund the rate for the unusable nights, but will not compensate other losses such as transportation costs.',
      ] },
      { title: 'Changes to these Terms', body: ['We may revise these Terms as necessary. We will post the changes and their effective date on the Site at least one week in advance. Using our services on or after the effective date constitutes agreement to the revised Terms.'] },
      { title: 'Governing Law and Jurisdiction', body: ['These Terms are governed by the laws of Japan. The Tokyo District Court shall have exclusive jurisdiction in the first instance.'] },
    ],
    dates: ['Established: October 9, 2026'],
  },
  zh: {
    eyebrow: 'Terms',
    title: '使用条款',
    lead: '本使用条款（以下简称“本条款”）规定了 Stay Dream Hotel（以下简称“本设施”）预订网站及住宿服务的使用条件与入住规则。为确保您安全舒适地入住，预订前请务必仔细阅读。',
    sections: [
      { title: '适用范围', body: ['本条款适用于通过本设施预订网站（以下简称“本网站”）进行的所有预订及住宿。完成预订即视为同意本条款。', '如不遵守本条款，本设施可能拒绝您的住宿或设施使用。因不遵守本条款而发生的事故，本设施概不负责。'] },
      { title: '预订成立', body: ['在本网站填写必要信息并完成支付后，预订即告成立。未完成支付的，预订不成立。'] },
      { title: '费用与支付', list: ['住宿费用以预订页面显示的金额（含税）为准。', '支付方式为信用卡等本网站指定的方式。', '可能另行产生住宿税等公共费用。', '追加费用及违约金须在退房日前付清。'] },
      { title: '取消政策', list: ['入住日30天前取消：全额退款', '此后取消或未入住（No-show）：不予退款', '长期住宿中途取消的，不予退款。', '退款将原路退回，可能扣除支付手续费。', '通过 Airbnb 等其他网站预订的，适用各网站的取消政策。'] },
      { title: '入住与退房', list: ['入住：16:00以后', '退房：10:00以前', '请严格遵守时间，并按照退房流程办理。'] },
      { title: '设施使用须知', list: [
        '除阳台外，室内禁止穿鞋。请勿穿室内拖鞋外出。',
        '包括阳台在内全面禁烟。此处为住宅区，请特别注意防火。',
        '仅限预订登记的客人及人数入住。禁止非预订人员住宿或以不同人数使用、停留。',
        '在房间内，特别是就寝时，请务必从内侧上锁。抵达后请确认设施内的避难路线。',
        '外出时请关闭所有门窗，并关闭空调、电视、照明等电器电源。',
        '严禁举办聚会或喧哗。尤其是21:00至7:00，请顾及邻居，保持安静。',
        '未经许可，请勿将客房用于展览、办公等住宿以外的用途。',
        '谢绝携带宠物入住。',
        '未经监护人许可，谢绝仅由未成年人入住。',
        '外国游客须依法事先提供护照复印件。',
        '请坐着使用马桶，除卫生纸外请勿冲入其他物品。',
        '长期住宿不会产生任何居住相关的法律权利。',
      ] },
      { title: '用电须知', body: ['各设施的用电容量均有上限，每个插座上限通常为15A。开窗使用空调或在同一插座上使用大功率电器，可能导致自动断电甚至停电。使用空调时请关闭门窗，并合理使用水电。'] },
      { title: '备品与垃圾', list: [
        '请爱惜使用家具、家电、寝具等。如有损坏或污损，请及时告知。',
        '未经许可，请勿移动或改造家具、家电及备品。禁止带走备品。',
        '垃圾请分为“可燃垃圾”“不可燃垃圾”“罐・瓶・塑料瓶”，投入设施内指定的垃圾桶。详情请遵照设施内的说明。',
        '面巾、浴巾仅限最初提供的数量，不予追加或更换。',
        '已备有清扫用具，请保持室内清洁。',
      ] },
      { title: '玄关门钥匙', list: ['外出时请务必上锁。', '请勿将门钥匙（密码等）告知预订客人以外的人员。', '请妥善保管钥匙。遗失将产生高额费用（100,000日元以上）。'] },
      { title: '违约金与损害赔偿', body: ['出现以下情况时，将收取相应的违约金或赔偿金：'], list: [
        '在设施内吸烟：500,000日元（金额高昂）',
        '超员、虚报人数预订、非预订人员使用或停留：每超出或虚报1人每晚15,000日元',
        '家具、家电、寝具、备品等损坏或污损：按同等新品价格赔偿；如属故意或过失，另须赔偿恢复期间的停业损失',
        '因呕吐等造成家具、寝具、备品污损：无论原因，一律100,000日元',
        '遗失玄关门钥匙：实际费用（100,000日元以上）',
        '携带禁止物品或实施禁止行为（第12条）：300,000日元以上',
      ] },
      { title: '拒绝使用的情形', body: ['住客如有下列情形之一，本设施将立即拒绝其使用并要求退房。预订后或住宿期间发现的亦同，且不予退款。'], list: [
        '经查明为暴力团成员、相关团体或人员及其他反社会势力',
        '存在暴力、威胁、恐吓、威压性不当要求或类似行为',
        '曾被本设施通知拒绝使用者',
        '赌博、扰乱风纪或打扰邻居的言行',
        '因药物、饮酒等无法确保自身安全，或可能给邻居带来危险或不安',
        '大声喧哗、高声歌唱等打扰他人的行为',
        '违反本条款且不予改正，或有其他类似上述的行为',
      ] },
      { title: '禁止携带物品与禁止行为', body: ['如发现下列情形，本设施将立即拒绝使用并要求退房。'], list: [
        '携带动物、鸟类及其他宠物',
        '携带火药、挥发油等易燃易爆物品或散发恶臭的物品',
        '携带法律禁止持有的物品',
        '未经许可散发广告宣传品、销售物品或进行推销',
        '未经许可以营业为目的拍照或录像',
      ] },
      { title: '免责声明', list: [
        '非因本设施原因造成的住客财产或安全损失，本设施不承担责任。贵重物品请自行妥善保管。',
        '因自然灾害、事件或设备故障等导致设施无法使用时，退还无法使用之日起的住宿费，但交通费等其他损失不予补偿。',
      ] },
      { title: '条款变更', body: ['本设施可根据需要修改本条款。修改时，将于生效日前至少1周在本网站公布修改内容及生效日期。生效日后使用服务的，视为同意修改后的条款。'] },
      { title: '准据法与管辖', body: ['本条款适用日本法律。与本条款相关的争议，以东京地方法院为第一审专属管辖法院。'] },
    ],
    dates: ['制定日期：2026年10月9日'],
  },
};

const CONTACT_LABEL: Record<Lang, string[]> = {
  ja: ['お問い合わせ', '本規約に関するお問い合わせは、', 'お問い合わせフォーム', 'メール'],
  en: ['Contact', 'For questions about these Terms, please use the ', 'contact form', 'Email'],
  zh: ['联系我们', '如对本条款有任何疑问，请通过', '咨询表单', '邮箱'],
};

function TermsPage() {
  const lang = useLang();
  const c = CONTACT_LABEL[lang];
  return (
    <LegalDocument doc={DOCS[lang]}>
      <div className="legal-section">
        <h2>{`${DOCS[lang].sections.length + 1}. ${c[0]}`}</h2>
        <div className="gold-line" />
        <div className="legal-box">
          <p><strong>Stay Dream Hotel</strong></p>
          <p>{c[3]}：<a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></p>
          <p>{c[1]}<Link to="/contact">{c[2]}</Link></p>
        </div>
      </div>
    </LegalDocument>
  );
}

export default TermsPage;
